module.exports = __webpack_public_path__ + "img/collection_img01.63d2ba5a.jpg";